import { AbstractObject } from "../abstract-object";
import { LocalDateTime } from "../local-date-time/local-date-time";

/**
 * A kérdőív-kitöltésen adtto válasz adatstruktúrája.
 */
export class QuestionnaireResultAnswer extends AbstractObject {
    /**
     * Egy kérdésre adott válasz sorszáma.
     * - kötelező
     * - típusa integer
     * - meg kell, hogy egyezzen a kapcsolódo kéréds sorszámával (order)!
     */
    questionOrder: number = 0;

    /**
     * A kérdésre adott válasz.
     * - kötelező
     * Értékei:
     * - string: szabad szöveges válasz esetén;
     * - number: egyválasztós kérdés és Likert-skála esetén a választás 'order' értéke;
     *              VAGY
     *            "Likert" típusú szekció esetén a kiválasztott LikertValue 'value' mezőjének értéke.
     * - number[]: többválasztós kérdés esetén a választások 'order' értéke;
     */
    value: string | number | number[];

    /**
     * A kérdőív-válasz kitöltés kezdetének időpontja.
     * - 'Finished' státusz esetén kötelező
     */
    startedAt?: LocalDateTime = null;
    /**
     * A kérdőív-válasz kitöltés befejezésének időpontja.
     * - 'Finished' státusz esetén kötelező
     * - nem lehet kisebb, mint a startedAt
     */
    finishedAt?: LocalDateTime = null;

    /**
     * Az osztály konstruktora.
     * @param data 
     */
    constructor(data?: any) {
        super();
        super.init(data, this);
        if (this.startedAt) {
            this.startedAt = new LocalDateTime(this.startedAt);
        }
        if (this.finishedAt) {
            this.finishedAt = new LocalDateTime(this.finishedAt);
        }
    }
}
